import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//import Footer from "./Footer"; // The footer we built
import Home from "./Pages/Home";
import About from "./Pages/About";
import Portfolio from "./Pages/Portfolio";
import Inquire from "./Pages/Inquire/Inquire";
import AlbumView from "./Pages/AlbumView";
import NavBar from "./Components/NavBar";
import Pricing from "./Pages/Pricing";
import Testimonials from "./Pages/Testimonials";
import Footer from "./Components/Footer";

function App() {
  return (
    <>
      <Router>
        <div>
          <NavBar />
          {/* Main Content */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/inquire" element={<Inquire />} />
            <Route path="/album/:album" element={<AlbumView />} />
            <Route path="/*" element={<Home />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
